import { render, staticRenderFns } from "./polygonController.vue?vue&type=template&id=ac026ed6&"
import script from "./polygonController.vue?vue&type=script&lang=ts&"
export * from "./polygonController.vue?vue&type=script&lang=ts&"
import style0 from "./polygonController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports